import { render } from "./EventCarousel.vue?vue&type=template&id=38f5cea5"
import script from "./EventCarousel.vue?vue&type=script&lang=js"
export * from "./EventCarousel.vue?vue&type=script&lang=js"

import "./EventCarousel.vue?vue&type=style&index=0&id=38f5cea5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__